export { useAdobeTarget } from './lib'
